import { useQuery } from "@tanstack/react-query";

import { createImpactReportQuery } from "./options";

export default function useImpactReportQuery() {
    return useQuery(createImpactReportQuery());
}
